import React, { useState, useEffect, useCallback } from 'react';
import { ExternalLink, Newspaper } from 'lucide-react';
import { Link } from 'react-router-dom';
import { API } from '../config';

function timeAgo(dateStr) {
  var now = new Date();
  var date = new Date(dateStr);
  var diff = Math.floor((now - date) / 1000);
  if (diff < 3600) return Math.floor(diff / 60) + 'm ago';
  if (diff < 86400) return Math.floor(diff / 3600) + 'h ago';
  if (diff < 604800) return Math.floor(diff / 86400) + 'd ago';
  return date.toLocaleDateString();
}

function RotatingCard(props) {
  var items = props.items;
  var delay = props.delay;
  var _idx = useState(0);
  var idx = _idx[0], setIdx = _idx[1];
  var _fade = useState(true);
  var fade = _fade[0], setFade = _fade[1];

  useEffect(function() {
    if (items.length <= 1) return;
    var t = setInterval(function() {
      setFade(false);
      setTimeout(function() {
        setIdx(function(p) { return (p + 1) % items.length; });
        setFade(true);
      }, 300);
    }, delay);
    return function() { clearInterval(t); };
  }, [items.length, delay]);

  if (items.length === 0) return null;
  var article = items[idx];

  return React.createElement('div', {
    className: 'bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-lg hover:border-blue-300 transition-all flex flex-col',
    style: { opacity: fade ? 1 : 0, transition: 'opacity 0.3s ease' }
  },
    React.createElement('div', { className: 'flex flex-wrap items-center gap-1 text-xs text-gray-400 mb-3' },
      React.createElement('span', { className: 'bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full text-xs font-medium' }, article.categoryName),
      React.createElement('span', { className: 'mx-1' }, '\u00b7'),
      React.createElement('span', null, article.source_icon + ' ' + article.source),
      React.createElement('span', { className: 'mx-1' }, '\u00b7'),
      React.createElement('span', null, timeAgo(article.published_at))
    ),
    React.createElement('h3', { className: 'text-lg font-bold text-gray-900 mb-2 line-clamp-2 flex-grow' }, article.title),
    React.createElement('p', { className: 'text-sm text-gray-500 mb-4 line-clamp-3' }, article.summary),
    React.createElement('a', { href: article.url, target: '_blank', rel: 'noopener noreferrer', className: 'inline-flex items-center gap-1 text-blue-600 font-medium text-sm hover:text-blue-800 transition-colors mt-auto' },
      'Read more ',
      React.createElement(ExternalLink, { size: 14 })
    )
  );
}

export default function NewsHighlights() {
  var _articles = useState([]);
  var articles = _articles[0], setArticles = _articles[1];
  var _loading = useState(true);
  var loading = _loading[0], setLoading = _loading[1];

  useEffect(function() {
    fetch(API + '/news/by-category?limit=3')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var all = [];
        var cats = data.categories || {};
        Object.keys(cats).forEach(function(slug) {
          var cat = cats[slug];
          if (cat.articles) {
            cat.articles.forEach(function(a) {
              all.push(Object.assign({}, a, { categoryName: cat.name, categoryIcon: cat.icon }));
            });
          }
        });
        setArticles(all);
        setLoading(false);
      })
      .catch(function() { setLoading(false); });
  }, []);

  if (loading || articles.length === 0) return null;

  // Split articles into 3 groups for each card slot
  var slot1 = [], slot2 = [], slot3 = [];
  articles.forEach(function(a, i) {
    if (i % 3 === 0) slot1.push(a);
    else if (i % 3 === 1) slot2.push(a);
    else slot3.push(a);
  });

  return React.createElement('section', { className: 'py-16 bg-white' },
    React.createElement('div', { className: 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8' },
      React.createElement('div', { className: 'text-center mb-10' },
        React.createElement('h2', { className: 'text-3xl md:text-4xl font-bold text-gray-900 mb-2' }, 'Latest Benefits News'),
        React.createElement('p', { className: 'text-gray-500' }, 'Fresh insights from trusted industry sources')
      ),
      React.createElement('div', { className: 'grid grid-cols-1 md:grid-cols-3 gap-6 mb-8' },
        React.createElement(RotatingCard, { items: slot1, delay: 8000 }),
        React.createElement(RotatingCard, { items: slot2, delay: 11000 }),
        React.createElement(RotatingCard, { items: slot3, delay: 14000 })
      ),
      React.createElement('div', { className: 'text-center mt-8' },
        React.createElement(Link, { to: '/news', className: 'inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 font-semibold transition-colors' },
          React.createElement(Newspaper, { size: 18 }),
          ' View all benefits news \u2192'
        )
      )
    )
  );
}
